import { render, staticRenderFns } from "./QuestionTypeAll.vue?vue&type=template&id=53928ecb"
import script from "./QuestionTypeAll.vue?vue&type=script&lang=js"
export * from "./QuestionTypeAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports